import { atom } from "jotai";

export const hasSessionBeenChecked_atom = atom<boolean>(false);
